/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * store how far a document has been read by a user
 */
export interface DocumentProgress {
  currentPage: number;
  totalPages: number;
}
